import { Loader } from '@lingoda/ui';
import { showErrorToast } from '@lingoda/toasts';
import { getApolloErrorUiMessage } from '@lingoda/monolith-graphql';
import { trans } from '@lingoda/i18n';
import { useAllAchievements } from '../../hooks/useAchievements';
import { AchievementsBoardLayout } from './AchievementsBoardLayout';

export const AchievementsBoard = () => {
    const { achievements, loading } = useAllAchievements({
        onError(error) {
            showErrorToast(getApolloErrorUiMessage(error) || trans('masked-error', {}, 'errors'));
        },
    });

    if (loading) {
        return <Loader />;
    }

    return <AchievementsBoardLayout achievements={achievements} />;
};
